// extracted by mini-css-extract-plugin
export default {"Wrapper":"IconButton_Wrapper__DCEc0","Container":"IconButton_Container__0uLAz","Icon":"IconButton_Icon__q-GiQ","Text":"IconButton_Text__YpuDU"};